"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _image = _interopRequireDefault(require("./image"));
var _membership_type = _interopRequireDefault(require("./membership_type"));
var _moment = _interopRequireDefault(require("moment"));
var _target_language = _interopRequireDefault(require("./target_language"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var UserBasic = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_membership_type["default"])), _dec3 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_target_language["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function UserBasic() {
    var _this;
    _classCallCheck(this, UserBasic);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserBasic, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "email", _descriptor3, _this);
    _initializerDefineProperty(_this, "todaysDate", _descriptor4, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor5, _this);
    _initializerDefineProperty(_this, "xp", _descriptor6, _this);
    _initializerDefineProperty(_this, "dailyXpGoal", _descriptor7, _this);
    _initializerDefineProperty(_this, "canAccessAdminSite", _descriptor8, _this);
    _initializerDefineProperty(_this, "canAccessAdminPosts", _descriptor9, _this);
    _initializerDefineProperty(_this, "canAccessAdminUsers", _descriptor0, _this);
    _initializerDefineProperty(_this, "userDataAccessLevel", _descriptor1, _this);
    _initializerDefineProperty(_this, "canUpdateRecords", _descriptor10, _this);
    _initializerDefineProperty(_this, "canDeleteRecords", _descriptor11, _this);
    _initializerDefineProperty(_this, "currentStreakCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "currentDayXp", _descriptor13, _this);
    _initializerDefineProperty(_this, "role", _descriptor14, _this);
    _initializerDefineProperty(_this, "admin", _descriptor15, _this);
    _initializerDefineProperty(_this, "autoHideComments", _descriptor16, _this);
    _initializerDefineProperty(_this, "mailerliteId", _descriptor17, _this);
    _initializerDefineProperty(_this, "image", _descriptor18, _this);
    _initializerDefineProperty(_this, "membershipType", _descriptor19, _this);
    _initializerDefineProperty(_this, "lastActiveAt", _descriptor20, _this);
    _initializerDefineProperty(_this, "targetLanguages", _descriptor21, _this);
    return _this;
  }
  _inherits(UserBasic, _RootModel);
  return _createClass(UserBasic, [{
    key: "hasMembershipType",
    get: function get() {
      return (0, _utils.isPresent)((0, _mobx.toJS)(this.membershipType));
    }
  }, {
    key: "pro",
    get: function get() {
      return this.hasMembershipType && this.membershipType.slug === 'pro';
    }
  }, {
    key: "isMember",
    get: function get() {
      return this.anyAdmin || this.successfulCheckout || this.permanentMembership || this.pro;
    }
  }, {
    key: "imageUrl",
    get: function get() {
      var _this$image$url, _this$image;
      return (_this$image$url = (_this$image = this.image) === null || _this$image === void 0 ? void 0 : _this$image.url) !== null && _this$image$url !== void 0 ? _this$image$url : null;
    }
  }, {
    key: "firstName",
    get: function get() {
      if ((0, _utils.isPresent)(this.name)) {
        var first = this.name.split(' ')[0];
        return first.length > 12 ? "".concat(first.slice(0, 12), "..") : first;
      }
      return 'Guest';
    }
  }, {
    key: "todaysDateMoment",
    get: function get() {
      return (0, _moment["default"])(new Date(this.todaysDate));
    }
  }, {
    key: "tomorrowsDate",
    get: function get() {
      return this.todaysDateMoment.add(1, 'day').toDate();
    }
  }, {
    key: "tomorrowsDateMoment",
    get: function get() {
      return (0, _moment["default"])(this.tomorrowsDate);
    }
  }, {
    key: "title",
    get: function get() {
      if (this.admin) {
        return 'Seedlang Admin';
      }
      if (this.translator) {
        return 'Seedlang Translator';
      }
      if (this.moderator) {
        return 'Seedlang Moderator';
      }
      if (this.pro) {
        return 'Seedlang Pro';
      }
      return null;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "email", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "todaysDate", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "xp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "dailyXpGoal", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminSite", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminPosts", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "canAccessAdminUsers", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "userDataAccessLevel", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canUpdateRecords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "canDeleteRecords", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "currentStreakCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "currentDayXp", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "role", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "admin", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "autoHideComments", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "mailerliteId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "membershipType", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "lastActiveAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "targetLanguages", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasMembershipType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMembershipType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pro", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pro"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMember", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "todaysDateMoment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "todaysDateMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tomorrowsDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tomorrowsDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tomorrowsDateMoment", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tomorrowsDateMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "title"), _class.prototype), _class);
var _default = exports["default"] = UserBasic;